import React from "react";
import { number, object } from "prop-types";
import MapShape from "components/MapShape/ForInitialSetup";
import { deviceFloorLevel, mapOrientation } from "config/constants";
import { cacheItem, getCachedItem } from "utils/localStorage";

SettingChooseOrientation.propTypes = {
  styles: object,
  mapLevel: number,
};

function SettingChooseOrientation(props) {
  const { mapLevel } = props;

  const [mapOrient, setMapOrient] = React.useState(
    getCachedItem(mapOrientation) || 0
  );

  const defaultProps = {
    name: deviceFloorLevel,
    onChange: (e) => {
      setMapOrient(+e.target.value);
    },
    defaultValue: getCachedItem(mapOrientation),
  };

  return (
    <div>
      <div className="form-row pb-5">
        <select {...defaultProps} style={{ width: 280 }}>
          <option value="0">Nguyên bản</option>
          <option value="90">Xoay 90 độ</option>
          <option value="180">Xoay 180 độ</option>
          <option value="270">Xoay 270 độ</option>
        </select>
        <button
          type="button"
          className="btn btn-primary ml-3"
          onClick={() => cacheItem(mapOrientation, mapOrient)}
        >
          Submit
        </button>
      </div>
      <MapShape floorIndex={mapLevel} rotate={mapOrient} />
    </div>
  );
}

export default SettingChooseOrientation;
